import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { value: "es" }
const _hoisted_16 = { value: "eu" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "indicator-label" }
const _hoisted_22 = { class: "indicator-progress" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_24 = { class: "card mb-5 mb-xl-10" }
const _hoisted_25 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-target": "#kt_account_signin_method"
}
const _hoisted_26 = { class: "card-title m-0" }
const _hoisted_27 = { class: "fw-boldest m-0" }
const _hoisted_28 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_29 = { class: "card-body border-top p-9" }
const _hoisted_30 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_31 = { class: "fs-4 fw-boldest mb-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_33 = { class: "fs-6 fw-bold text-gray-600 mb-4" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4" }
const _hoisted_36 = { class: "fv-row mb-0" }
const _hoisted_37 = {
  for: "oldPassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "col-lg-4" }
const _hoisted_41 = { class: "fv-row mb-0" }
const _hoisted_42 = {
  for: "Password",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = { class: "fv-row mb-0" }
const _hoisted_47 = {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "d-flex" }
const _hoisted_51 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_52 = { class: "indicator-label" }
const _hoisted_53 = { class: "indicator-progress" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("userDetails")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveChanges()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("beach")), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "beach",
                    class: "form-select form-select-solid form-select-lg fw-bold",
                    modelValue: _ctx.selectedBeach,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBeach) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableBeachs, (beach) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: beach.Id,
                          key: beach
                        }, _toDisplayString(beach.Name), 9, _hoisted_11))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("language")), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "language",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.selectedLanguage,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLanguage) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("spanish")), 1),
                      _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t("euskera")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "language" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.selectedBeach && _ctx.selectedLanguage)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    id: "kt_account_profile_details_submit",
                    ref: "submitButton1",
                    class: "btn btn-primary",
                    disabled: 
              _ctx.selectedBeach == _ctx.siteId() && _ctx.selectedLanguage == _ctx.language()
            
                  }, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("saveChanges")), 1),
                    _createElementVNode("span", _hoisted_22, [
                      _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                      _hoisted_23
                    ])
                  ], 8, _hoisted_20))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t("changePassword")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
            }, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("password")), 1),
              _hoisted_32
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("minSecurityPassword")), 1),
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _ctx.updatePassword,
                "validation-schema": _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("currentPassword")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "oldPassword",
                          id: "oldPassword"
                        }),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_ErrorMessage, { name: "oldPassword" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("oldPasswordRequired")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("newPassword")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "Password",
                          id: "Password"
                        }),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_ErrorMessage, { name: "newPassword" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("newPasswordRequired")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("confirmNewPassword")), 1),
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "form-control form-control-lg form-control-solid fw-bold fs-6",
                          name: "confirmpassword",
                          id: "confirmpassword"
                        }),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_ErrorMessage, { name: "confirmpassword" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("repeatPasswordNotIdentical")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("updatePassword")), 1),
                      _createElementVNode("span", _hoisted_53, [
                        _createTextVNode(_toDisplayString(_ctx.$t("sending")) + " ", 1),
                        _hoisted_54
                      ])
                    ], 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, _toDisplayString(_ctx.$t("cancel")), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-light fw-boldest"
              }, _toDisplayString(_ctx.$t("changePassword")), 1)
            ], 2)
          ])
        ])
      ])
    ])
  ], 64))
}